export default __webpack_public_path__ + "static/media/Circlet of the Nebulous.09dccde8.jpg";